import { useRouter } from 'next/router';

import { getActiveSubscriptionCookie } from '~/features/cookies/utils/get-active-subscription-cookie';
import { useUser } from '~/features/user/hooks/use-user';
import { extractCompanySlug } from '~/utils/extract-company-slug';

export function useCourseLink({ courseSlug }: { courseSlug: string }) {
  const router = useRouter();
  const { userCatalog } = useUser();
  const userHasAllAccess = getActiveSubscriptionCookie();
  const companySlugQueryParam = router.query.companySlug;
  const companySlug = extractCompanySlug(userCatalog?.catalogUrl);

  // If the company slug is in the query params we know we're on an enterprise page and we need to always link to the enterprise plp
  if (companySlugQueryParam) {
    return `/org/${companySlugQueryParam}/course/${courseSlug}`;
  }
  // If the user is an enterprise user (determined by the companySlug), and doesn't have all access, we always link to the enterprise plp
  // This allows enterprise users who also have a consumer subscription to access the consumer plp by default, but also allows them to access the enterprise in the right context
  if (companySlug && !userHasAllAccess) {
    return `/org/${companySlug}/course/${courseSlug}`;
  }

  return `/course/${courseSlug}`;
}
